import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {

    transform(
        value: number | string,
        currencySymbol: string = '€'
    ): string {
        if (value == null) return '';

        if(!currencySymbol) {
            currencySymbol = '€';
        }

        const num = Number(value);
        if (isNaN(num)) return value.toString();

        // auf 2 Nachkommastellen runden
        const formatted = num.toFixed(2).replace(".", ",");

        // mit Währungssymbol zurückgeben
        return `${formatted} ${currencySymbol}`;
    }
}
